const urls = {
    // root: '/zxauth',
    root: '/gc',
    index: {
        login: '/auth/index/login',
        logout: '/auth/index/logout',
        getMenu: '',
        getSource: ''
    },
    system: {
        upload: '/auth/zx-system/upload',
        downloadFastDFS: '/auth/zx-system/downFastDFS',
        downFile: '/auth/zx-system/downFile',
        validateDbConnect: '/auth/zx-system/validateDbConnect',
        getTableData: '/auth/zx-system/getTableData'
    },
    business: {
        // zxUser: '/auth/zx-user/base'
        zxUser: '/index/baseResult.do',
        downLoad: '/indexCommon',
        uploadImg: '/common'
    }
}
const tempMenu = [
  {
    name: '大屏展示',
    url: '/countyControl/prefectureScreen',
    icon: '',
    code: '20011002',
    children: null
  },
  {
    name: '统计查询',
    url: '3453',
    icon: '',
    code: '20011003',
    children: [{
      name: '报抽统计',
      url: '/villagesBCStatistics',
      icon: '',
      code: '20021001',
      children: null
    },
      {
        name: '报修统计',
        url: '/villagesBXStatistics',
        icon: '',
        code: '20021002',
        children: null
      },
      {
        name: '统计导出',
        url: '/statisticalReport',
        icon: '',
        code: '20021002',
        children: null
      }
    ]
  },
  {
    name: '改厕档案信息管理',
    url: '/gCArchivesInfoTable',
    icon: '',
    code: '20011004',
    children: null
  },
  {
    name: '大数据分析',
    url: '/dataAnalysis',
    icon: '',
    code: '20011005',
    children: [{
      name: '抽厕分析',
      url: '/dataAnalysis/wcAnalysis',
      icon: '',
      code: '21211001',
    },{
      name: '维修分析',
      url: '/dataAnalysis/Maintenance',
      icon: '',
      code: '21211002',
    },{
      name: '作业量分析',
      url: '/dataAnalysis/analyze',
      icon: '',
      code: '21211003',
    },{
      name: '满意度排行',
      url: '/dataAnalysis/SatisfactionAnalysis',
      icon: '',
      code: '21211004',
    }]
  },
  {
    name: '通知公告',
    url: '',
    icon: '',
    code: '20011006',
    children: [{
      name: '通知公告栏目配置',
      url: '/notice',
      icon: '',
      code: '20021003',
      children: null
    },
      {
        name: '通知公告详情',
        url: '/noticeDetail',
        icon: '',
        code: '20021004',
        children: null
      }
    ]
  },
  {
    name: '功能设置',
    url: '20011007',
    icon: '',
    code: '20011007',
    children: [{
      name: '用户管理',
      url: '/user',
      icon: '',
      code: '10011001',
      children: null
    },{
      name: '系统配置',
      url: '/SetSwitch',
      icon: '',
      code: '200110071001',
      children: null
    },
      {
        name: '车辆分工管理',
        url: '/carsLabor',
        icon: '',
        code: '200110071002',
        children: null
      }
    ]
  },
    {
      name: '工作台',
      url: '4',
        icon: '',
        code: '',
        children: [{
          name: '报抽管理',
          url: '/workbench',
            icon: '',
            code: '8786546',
            children: null
        },{
          name: '报修管理',
          url: '/bxManage',
            icon: '',
            code: '8786547',
            children: null
        }, {
          name: '报修记录',
          url: '/careOf',
          icon: '',
          code: '6765',
          children: null
        }, {
          name: '报抽记录',
          url: '/BcTable',
          icon: '',
          code: '',
          children: null
        },{
          name: '日志查看',
          url: '/logManagement',
          icon: '',
          code: '',
          children: null
        }
        ]
    }
]

export default {
    urls,
    tempMenu
}



// WEBPACK FOOTER //
// ./src/assets/js/config.js